import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/helpers/classNames"

function Checkbox({
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ElementRef<typeof CheckboxPrimitive.Root>>
} & React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        `
          peer size-4 shrink-0 rounded-sm border border-primary-400
          ring-offset-background
          focus-visible:ring-2 focus-visible:ring-ring
          focus-visible:ring-offset-2 focus-visible:outline-hidden
          disabled:cursor-not-allowed disabled:opacity-50
          data-[state=checked]:bg-primary-300
          data-[state=checked]:text-neutral-100
        `,
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn("flex items-center justify-center text-current")}
      >
        <Check className="size-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
